import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 511.9 511.9" style={{
  enableBackground: "new 0 0 511.9 511.9"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#FFE15A"
  }} d="M473.7,423.65H38.3c-21.1,0-38.3-17.1-38.3-38.3v-258.8c0-21.2,17.2-38.3,38.3-38.3h435.3  c21.2,0,38.3,17.2,38.3,38.3v258.8C512,406.55,494.8,423.65,473.7,423.65z" /><path style={{
    fill: "#464655"
  }} d="M38.3,88.25c-21.1,0-38.3,17.1-38.3,38.3v258.8c0,21.2,17.2,38.3,38.3,38.3h132.3V88.25H38.3z" /><path style={{
    fill: "#FF4B55"
  }} d="M473.7,88.25H341.3l0,0v335.4l0,0h132.3c21.2,0,38.3-17.2,38.3-38.3v-258.8  C512,105.35,494.8,88.25,473.7,88.25z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };